import client from './AxiosClient'

const categoryService = {
    filter : (params) => client.get("/category/filter", { params }),
    create : (data) => client.post("/category", data),
    update: (data, params) => client.put(`/category`, data, { params }),
    delete : (id) => client.delete(`/category?id=${id}`),
}

export default categoryService;